import React, { useState } from "react";
import ResponsiveTable from "./ResponsiveTable";

const FamilyView = ({ currentRecord }) => {
  const [jsonData, setJsonData] = useState({
    ...currentRecord,
    date_of_birth: [
      currentRecord?.birth_day,
      currentRecord?.birth_month,
      currentRecord?.birth_year
    ].filter(Boolean).join("/"),
  });
  const selectedKeys = [
    "full_name",
    "first_name",
    "last_name",
    "mobile",
    "mobile",
    "email",
    "blood_group",
    "date_of_birth",
    "birth_day",
    "birth_month",
    "birth_year",
    "qualification",
    "birth_place",
  ];
  return (
    <div className="">
      <div className="flex justify-center items-center w-full">
        {currentRecord?.image && (
          <img
            crossOrigin="anonymous"
            src={`${process.env.REACT_APP_REPORTS_DOWNLOAD_URL}uploads/family/${currentRecord?.image}`}
            alt="Image"
            className="w-[400px] p-1 mr-1"
          />
        )}
      </div>
      <div className="p-6">
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {selectedKeys.map((key, index) => (
            <div key={index} className="p-2 border">
              <div className="font-bold capitalize">
                {key.replace(/_/g, " ")}
              </div>
              <div className="mt-1">{jsonData[key]?.toString()}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FamilyView;
